import { createFetchSelector } from '@copilot/common/store/selectors/fetch';
import { TAGS } from './constant';
import { Tag } from './models';

export const getAllOrgTags = createFetchSelector<Tag>(TAGS);
